export const localeFormatDefault = {
  dateFormat: 'YYYY-MM-DD',
  dayFormat: 'dd, D.MMM',
  dayShortFormat: 'MM.D',
  dayFullFormat: 'dddd, MMM D',
  timeFormat: 'h:mm a',
  timeFormatShort: 'h a',
};

export const localeFormats = {
  en: {
    dateFormat: 'YYYY-MM-DD',
    dayFormat: 'dddd, MMM.D',
    dayShortFormat: 'MM.D',
    dayFullFormat: 'dddd, MMM D',
    timeFormat: 'h:mm a',
    timeFormatShort: 'h a',
  },
  de: {
    dateFormat: 'DD-MM-YYYY',
    dayFormat: 'dddd, DD.MMM',
    dayShortFormat: 'DD.MM',
    dayFullFormat: 'dddd, D. MMM',
    timeFormat: 'HH:mm',
    timeFormatShort: 'HH:mm',
  },
  fr: {
    dateFormat: 'YYYY-MM-DD',
    dayFormat: 'dddd, MMM.D',
    dayShortFormat: 'MM.D',
    dayFullFormat: 'dddd, MMM D',
    timeFormat: 'h:mm a',
    timeFormatShort: 'h a',
  },
  it: {
    dateFormat: 'DD-MM-YYYY',
    dayFormat: 'dddd, DD.MMM',
    dayShortFormat: 'DD.MM',
    dayFullFormat: 'dddd, D. MMM',
    timeFormat: 'HH:mm',
    timeFormatShort: 'HH:mm',
  },
  nl: {
    dateFormat: 'DD-MM-YYYY',
    dayFormat: 'dddd, DD.MMM',
    dayShortFormat: 'DD.MM',
    dayFullFormat: 'dddd, D. MMM',
    timeFormat: 'HH:mm',
    timeFormatShort: 'HH:mm',
  },
  ru: {
    dateFormat: 'DD-MM-YYYY',
    dayFormat: 'dddd, DD.MMM',
    dayShortFormat: 'DD.MM',
    dayFullFormat: 'dddd, D. MMM',
    timeFormat: 'HH:mm',
    timeFormatShort: 'HH:mm',
  },
};
